module.exports = __webpack_public_path__ + "static/img/核算通_内训版_封面.6a4d3ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/核算通_内训版_封面.jpg
// module id = zgLc
// module chunks = 1